<!--
  Standard form-control markup: a sem-control-label caption, the classic Material dropdown the other
  controls use (classic-dropdown + disabled-field-dd), text-button actions. Every visible word comes
  from `labels`, resolved server-side. Styles live in assets/css/platform.scss (.SemRelatedEntitiesControl).
-->
<div class="sem-related-entities" [class.re-readonly]="!canEdit" data-test="related-entities">

  <!-- Title: a field caption, or the same section heading a Section title control draws (frm-section
       is what the theme styles as text + line), so the control can head its own form section. -->
  <div class="form-group re-title" *ngIf="settings?.Title && !titleAsSection">
    <label class="sem-control-label">{{ settings.Title }}</label>
  </div>
  <div class="SectionTitleControl re-section" *ngIf="settings?.Title && titleAsSection">
    <p class="frm-section">{{ settings.Title }}</p>
  </div>

  <div class="re-error" *ngIf="configurationError" data-test="re-config-error">
    {{ configurationError }}
  </div>

  <ng-container *ngIf="!configurationError">

    <div class="re-note" *ngIf="!hasParent" data-test="re-no-parent">{{ labels.SaveFirst }}</div>

    <ng-container *ngIf="hasParent">

      <!-- Combobox: the relationship holds one target. -->
      <div class="re-combo SemDropDownSelectControl" *ngIf="!isList">
        <mat-form-field class="classic-dropdown re-field" [hideRequiredMarker]="true"
                        [ngClass]="{ 'disabled-field-dd': !canEdit || busy }">
          <div class="dd-delete" *ngIf="canEdit && !busy && selectedTargetId != null"
               data-test="re-combo-clear" (click)="clearCombobox($event)"></div>
          <mat-select [(ngModel)]="selectedTargetId"
                      [disabled]="!canEdit || busy"
                      [name]="'re-combo-' + settings.LinkClass"
                      [placeholder]="labels.Pick"
                      data-test="re-combo"
                      (selectionChange)="onComboboxChange($event.value)">
            <mat-option *ngFor="let o of options" [value]="o.Id" [attr.data-test]="'re-option-' + o.Id">
              {{ o.Title }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- List: the relationship holds many, and every column the operator added shows beside them. -->
      <div class="re-list" *ngIf="isList">

        <div class="re-table" *ngIf="rows.length > 0">
          <div class="re-row re-head">
            <div class="re-cell re-name">{{ labels.Link }}</div>
            <div class="re-cell" *ngFor="let c of columns">{{ c.Label }}</div>
            <div class="re-cell re-actions"></div>
          </div>

          <div class="re-row" *ngFor="let r of rows; trackBy: trackRow"
               [attr.data-test]="'re-row-' + r.Id">
            <div class="re-cell re-name" [attr.data-test]="'re-row-title-' + r.Id" [title]="r.TargetTitle">{{ r.TargetTitle }}</div>
            <div class="re-cell" *ngFor="let v of r.Values"
                 [attr.data-test]="'re-row-' + r.Id + '-' + v.Column" [title]="v.Value">{{ v.Value }}</div>
            <div class="re-cell re-actions">
              <button type="button" class="re-action re-remove"
                      *ngIf="canEdit && settings.AllowRemove"
                      [disabled]="busy"
                      [attr.data-test]="'re-remove-' + r.Id"
                      (click)="removeRow(r)">{{ labels.Remove }}</button>
            </div>
          </div>
        </div>

        <div class="re-note" *ngIf="rows.length === 0" data-test="re-empty">{{ labels.Empty }}</div>

        <div class="re-add SemDropDownSelectControl" *ngIf="canEdit && settings.AllowAdd">
          <mat-form-field class="classic-dropdown re-field" [hideRequiredMarker]="true"
                          [ngClass]="{ 'disabled-field-dd': busy }">
            <mat-select [(ngModel)]="pendingTargetId"
                        [disabled]="busy"
                        [name]="'re-pick-' + settings.LinkClass"
                        [placeholder]="labels.Pick"
                        data-test="re-picker">
              <mat-option *ngFor="let o of options" [value]="o.Id" [attr.data-test]="'re-pick-' + o.Id">
                {{ o.Title }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <button type="button" class="re-action re-addbtn"
                  [disabled]="busy || pendingTargetId == null"
                  data-test="re-add"
                  (click)="addRow()">{{ labels.Add }}</button>
        </div>
      </div>

      <div class="re-error" *ngIf="serverError" data-test="re-server-error">{{ serverError }}</div>

    </ng-container>
  </ng-container>
</div>
